<template>
  <div class="login">

    <div class="login__content">

      <h1 class="logo logo--login" :style="{ 'background-image': 'url(\'brand/rose-logo.png\')' }"><span class="logo__text">Rose &amp; Associates</span></h1>
      <form class="login__form" method="post" action="/" name="loginform">

        <div class="text-wrap">
          <label class="label input__label" for="login_input_username">Username</label>
          <input id="login_input_username" class="input input--text" type="text" name="user_name" required />
        </div>

        <div class="text-wrap">
          <label class="label input__label" for="login_input_password">Password</label>
          <input id="login_input_password" class="input input--text" type="password" name="user_password" autocomplete="off" required />
        </div>

        <input class="button" type="submit"  name="login" value="Log in" />

      </form>

    </div>

  </div>
</template>

<script>

export default {
  
  

}

</script>

<style lang="scss">

  .logo--login {

    display: block;
    margin: 0 auto 3rem;

  }

  .login {
    padding: 1rem;
    background: #f2f2f2; 
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    display: flex;
    align-items: center;
    justify-content: center;

  }

  .login__form {

    background: #fff;
    padding: 2.5rem;

    .text-wrap {

      margin-bottom: .5rem;

    }

    .label {

      color: #444;
      
    }

    .input {

      background: #f2f2f2;
      color: #222;
      box-shadow: 0 0 5px rgba(0, 0, 0, .05);
      border: 1px solid #e2e2e2;
      width: 18rem;

    }

    .button {

      margin-top: 1rem;
      line-height: 1em;
      padding-top: 9px;

    }

  }

</style>



// WEBPACK FOOTER //
// Login.vue?58e02b4a